import React, { Fragment, useEffect, useState } from 'react';
import { Button }from '@cmsgov/design-system';

import { FormattedMessage } from 'react-intl';

// Components

import ModalHeader from '../../common/headers/ModalHeader';
import Form from '../../../lib/wrappers/Form';
import OtherAddressInputs from '../pages/pageIncludes/common/address/OtherAddressInputs';

// Utils

import validators from '../../../utils/validators/validators';

// Constants

import { VALIDATION_TYPES } from '../../../constants/inputs/validationTypes';


const OtherAddressModal = props => {

    const {
        actions: {
            changeData,
            fetchCountiesForZipcode,
            hideModal,
            setCounty
        },
        bottomAnchors: [
            anchor_1,
        ],
        boundAnchor,
        counties,
        data,
        formName,
        methods,
        modal: {
            modalData: {
                defaultMailingAddressId,
                index,
                itfFeatureEnabled,
                otherAddress,
                pageName,
            }
        },
        modalHeaderProps
    } = props;

    const [ localState, setLocalState ] = useState({
        ...otherAddress,
    });

    const {
        postalCode,
        state
    } = localState;

    const isPostalCodeValid = validators
        .find(validator => validator.validatorType === VALIDATION_TYPES.ZIP_CODE)
        .verifier({ value: postalCode });

    useEffect(() => {
        if(state && isPostalCodeValid) {
            fetchCountiesForZipcode(state, postalCode.slice(0, 5), pageName);
        }
    }, [ `${state}${postalCode}` ]);

    const fetchedCounties = (cc => cc ? cc : [])(counties[pageName]);

    const syncUpCountyRelatedProps = () => {

        const [ updFips, updCounty ] =
            (c => c ? Object.entries(c)[0] : [ localState.primaryAddressCountyFipsCode, localState.county ] )(fetchedCounties.find(c => c[localState.countyCode]));

        setLocalState(localState => ({
            ...localState,
            county: updCounty,
            primaryAddressCountyFipsCode: updFips
        }));
    };

    useEffect(() => {
        if(localState.countyCode) {
            syncUpCountyRelatedProps();
        }
    }, [ localState.countyCode ]);

    useEffect(() => {
        if(fetchedCounties.length === 1) {

            const { countyCode } = fetchedCounties
                .reduce((res, c) => {
                    const [ countyCode ] = Object.entries(c)[0];
                    return {
                        ...res,
                        countyCode
                    };
                }, {});

            setLocalState(localState => ({
                ...localState,
                countyCode
            }));
        }
    }, [ fetchedCounties.map(c => Object.keys(c)).toString() ]);

    useEffect(() => {
        if(!isPostalCodeValid) {
            fetchedCounties.length > 0 && setCounty([], pageName);

            setLocalState(localState => ({
                ...localState,
                countyCode: null
            }));
        }
    }, [ postalCode ]);

    const handleSaveClick = () => {

        const updateData = () => {
            const newState = { ...data };

            if(index === null) {
                newState
                    .taxHousehold
                    .otherAddresses
                    .push(localState);
            } else {

                newState
                    .taxHousehold
                    .householdMember = newState
                        .taxHousehold
                        .householdMember
                        .reduce(
                            (hhms, hhm, idx) =>
                                [
                                    ...hhms,
                                    idx === 0
                                        ? hhm
                                        : {
                                            ...hhm,
                                            addressId: 1,
                                            ...(
                                                itfFeatureEnabled
                                                    ? { mailingAddressId: defaultMailingAddressId }
                                                    : {}
                                            )
                                        }
                                ],
                            []
                        );

                newState
                    .taxHousehold
                    .otherAddresses[index] = localState;
            }

            changeData(newState);
        };

        methods[formName].onFormSubmitForValidationOnly([updateData, () => hideModal()]);
    };

    const handleHideClick = () => hideModal();

    const onFieldChange = (...args) => {

        const [ newData, , , [ name ] ] = args;

        setLocalState(localState => ({
            ...localState,
            ...(name === 'state' ? { ...newData, countyCode: null } : newData)
        }));
    };

    return (
        <Fragment>
            <div className="gi-modal__header__head">
                <ModalHeader { ...modalHeaderProps } />
            </div>
            <div id = 'otherAddressModal' className="gi-modal__body">
                <Form { ...{ formName } } >
                    <OtherAddressInputs
                        {...{
                            ...localState,
                            counties: fetchedCounties,
                            currentData: localState,
                            inputActions: {
                                onFieldChange
                            },
                            underFormControl: true
                        }}
                    />
                </Form>
            </div>
            <div className='gi-modal__footer'>
                <div className='grid-row controls'>
                    <div className='grid-offset-4 txt-left'>
                        <Button
                            className='usa-button usa-button--outline gi-button gi-button__outline'
                            onClick={handleHideClick}
                        >
                            <FormattedMessage id='button.cancel'/>
                        </Button>
                        <Button
                            className='usa-button gi-button gi-button__primary'
                            onClick={handleSaveClick}
                            inputRef={boundAnchor(anchor_1)}
                        >
                            <FormattedMessage id='button.save'/>
                        </Button>
                    </div>
                </div>
            </div>

        </Fragment>
    );
};

export default OtherAddressModal;
